import { LocalDate } from "@js-joda/core";
import { Text } from "components/Typography/text.styled";
import { useState, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import {
  ArrowSign,
  MonthSelectContainer,
  SalaryPageContainer,
  Row,
  TooltipContainer,
  TooltipModal,
} from "./salary.styled";
import { FontFamily, FontSize } from "config/font";
import { Api } from "services/api/api.service";
import { FileViewer } from "../fileViewer/fileViewer.component";
import { AGIList } from "./agiList.component";

export const handlePreviousMonth = (setCurrentDate: any) => {
  return setCurrentDate((prevState: any) => prevState.minusMonths(1));
};

export const handleNextMonth = (setCurrentDate: any) => {
  return setCurrentDate((prevState: any) => prevState.plusMonths(1));
};

const AGITooltip = () => {
  const { t } = useTranslation();
  const [showInfo, setShowInfo] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setShowInfo(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setShowInfo(false);
  }, []);

  return (
    <TooltipContainer>
      <Row
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ cursor: "pointer" }}
      >
        <Text
          fontFamily={FontFamily.MontserratSemiBold}
          fontSize={FontSize.Small}
        >
          {t(`Salary.WhatIs`, {
            name: t("Salary.AGI").toLowerCase(),
          })}
        </Text>
      </Row>

      <TooltipModal
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          transform: showInfo ? "translateY(0)" : "translateY(-10px)",
          opacity: showInfo ? 1 : 0,
          visibility: showInfo ? "visible" : "hidden",
          pointerEvents: showInfo ? "auto" : "none",
          transition: "all 0.2s ease-in-out",
        }}
      >
        <Text fontSize={FontSize.Small}>{t("Salary.AGIInfo")}</Text>
      </TooltipModal>
    </TooltipContainer>
  );
};

export const AGIOverview = () => {
  const { t } = useTranslation();
  const [currentDate, setCurrentDate] = useState(
    LocalDate.now().minusMonths(1)
  );
  const [{ company }] = useCompanyStore();

  const formattedDate = useMemo(() => {
    return `${t(
      `CompanyTimeReport.${currentDate.month()}`
    )} ${currentDate.year()}`;
  }, [currentDate, t]);

  const handlePrev = useCallback(() => {
    handlePreviousMonth(setCurrentDate);
  }, [setCurrentDate]);

  const handleNext = useCallback(() => {
    handleNextMonth(setCurrentDate);
  }, [setCurrentDate]);

  return (
    <SalaryPageContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: 20,
          position: "relative",
        }}
      >
        <AGITooltip />
      </div>

      <MonthSelectContainer>
        <ArrowSign onClick={handlePrev}>&#60;</ArrowSign>
        <Text
          fontSize={FontSize.H4}
          fontFamily={FontFamily.MontserratSemiBold}
          style={{ margin: 0 }}
        >
          {formattedDate}
        </Text>
        <ArrowSign onClick={handleNext}>&#62;</ArrowSign>
      </MonthSelectContainer>

      {company && (
        <FileViewer
          fetchEndpoint={() =>
            Api().company.salary.getAGI(
              company.id,
              currentDate.year(),
              currentDate.monthValue()
            )
          }
          filename={`AGI_${currentDate.year()}_${currentDate.monthValue()}.xml`}
          type="application/xml"
          currentDate={currentDate}
          ListComponent={AGIList}
        />
      )}
    </SalaryPageContainer>
  );
};
